// SIWA GA metrics

export const GA_SIWA_EMAIL_ALREADY_EXISTS = 'SIWA_AccountAlreadyExists';
export const GA_SIWA_ACCOUNTS_LINKED = 'SIWA_AccountsLinked';
export const GA_SIWA_ACCOUNTS_LINK_OPTION = 'SIWA_AccountsLinkOption';
export const GA_SIWA_ACCOUNT_CREATED = 'SIWA_AccountCreated';
export const GA_SIWA_ACCOUNT_CREATED_FAILED = 'SIWA_AccountCreatedFailed';
export const GA_SIWA_POPUP_CLOSED = 'SIWA_PopupClosed';

export const GA_HIDDEN_EMAIL = 'hiddenEmail';
export const GA_SHOWED_EMAIL = 'showedEmail';
export const GA_EMAIL_NOT_FOUND = 'EmailNotFound';
export const GA_LINK_ACCOUNT_OPTION = 'linkAccountOption';
export const GA_TOKEN_EXPIRED = 'tokenExpired';

// Login
export const GA_LOGIN_CATEGORY = 'Login';
export const GA_LOGIN_CLICKED = 'LoginClicked';
export const GA_SIGNUP_CLICKED = 'SignUpClicked';
export const GA_LOGIN_SUCCESSFUL = 'LoginSuccessful';
export const GA_PASSWORD_INCORRECT = 'PasswordIncorrect';
export const GA_PASSWORD_VIEWED = 'PasswordViewed';
export const GA_PASSWORD_FORGOTTEN = 'PasswordForgotten';
export const GA_PASSWORD_FORGOTTEN_MAIL_FAILED = 'PasswordForgottenMailFailed';
export const GA_PASSWORD_FORGOTTEN_MAIL_SENT = 'PasswordForgottenMailSent';
export const GA_PASSWORD_RESETED = 'PasswordReseted';
export const GA_PASSWORD_RESETED_FAILED = 'PasswordResetedFailed';
export const GA_COMMUNITY_GUIDELINES_CLICKED = 'CommunityGuidelinesClicked';
export const GA_PRIVACY_POLICY_CLICKED = 'PrivacyPolicyClicked';
export const GA_TERMS_OF_SERVICE_CLICKED = 'TermsOfServiceClicked';
export const GA_USE_ANOTHER_ACCOUNT_CLICKED = 'UseAnotherAccountClicked';
export const GA_MAGIC_LINK_CLICKED = 'MagicLinkClicked';
export const GA_MAGIC_LINK_SENT = 'MagicLinkSent';
export const GA_MAGIC_LINK_FAILED = 'MagicLinkFailed';
export const GA_MAGIC_LINK_CONFIRMATION_CLOSED = 'MagicLinkConfirmationClosed';
export const GA_LINK_ACCOUNT_CLICKED = 'LinkAccountClicked';
export const GA_ACCOUNT_LINKED = 'AccountLinked';
export const GA_ACCOUNT_LOGIN_NOT_LINKED = 'LoginNotLinkedSuccessful';
export const GA_ACCOUNT_LINK_FAILED = 'AccountLinkFailed';
export const GA_ACCOUNT_LINK_CONFIRMATION_CLOSED =
    'AccountLinkConfirmationClosed';
export const GA_EVENTBRITE = 'Eventbrite';
